import React from 'react';
import { IQuestion, IChoices, IStatements } from '../properties/assessment';
import { useGetChoices } from '../properties/useGetChoices';
import { useGetStatements } from '../properties/useGetStatements';
import { Box, Typography } from '@mui/material';

interface LikertComponentProps {
    question: IQuestion;
    name: string;
    value?: string; // maps statementid to selected choiceid
    onChange: (statementId: string, selectedChoice: string) => void;
    onBlur: () => void;
  }
  
  const LikertComponent: React.FC<LikertComponentProps> = ({
    question,
    name,
    value,
    onChange,
    onBlur,
  }) => {
    const { choices } = useGetChoices(question.questionId || '') as { choices: IChoices[] };
    const { statements } = useGetStatements(question.questionId || '') as { statements: IStatements[] };
  
    const handleChange = (statementId: string, selectedChoice: string) => {
      onChange(statementId, selectedChoice);
    };
  
    return (
      <Box sx={{ overflowX: 'auto', mt: 3 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '8px' }}>Statements</th>
              {choices.map((choice) => (
                <th key={choice.choiceid} style={{ textAlign: 'center', padding: '8px' }}>
                  {choice.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {statements.map((statement) => (
              <tr key={statement.statementid}>
                <td style={{ padding: '8px', minWidth: '200px' }}>{statement.name}</td>
                {choices.map((choice) => (
                  <td key={choice.choiceid} style={{ textAlign: 'center', padding: '8px' }}>
                    <input
                      type="radio"
                      name={`${name}_${statement.statementid}`}
                      value={choice.choiceid}
                      checked={value?.[statement.statementid as any] === choice.choiceid}
                      onChange={() => handleChange(statement.statementid, choice.choiceid)}
                      onBlur={onBlur}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    );
  };
  
  export default LikertComponent;